import { dashboardServices } from './../../../../services';
import { endLoading, startLoading } from './../../../loader/redux/actions';
import { actionTypes } from './types';
import { handleError } from './../../../../utils';
import OpenFieldTypes from 'OpenFieldTypes';

export const dashboardActions = {
  getDashboardData,
  getUpcomingEvents,
  getReviews,
};

function getDashboardData(data: any, type?: string) {
  return (dispatch: OpenFieldTypes.RootAction) => {
    dispatch(request(data));
    dispatch(startLoading('MAIN_LOADER', 'Loading'));
    dashboardServices.getDashboardData(data)
      .then(
        (res) => {
          dispatch(endLoading('MAIN_LOADER'));
          const response = res;
          if (type) {
            response.type = type;
            dispatch(successType(response));
          } else {
            dispatch(success(response));
          }
        },
        (error) => {
          handleError(dispatch, failure, error.toString());
        },
      );
  };

  function request(res: any) { return { res, type: actionTypes.DASHBOARD_REQUEST }; }
  function success(res: any) { return { res, type: actionTypes.DASHBOARD_SUCCESS }; }
  function successType(res: any) { return { res, type: actionTypes.DASHBOARD_SUCCESS_TYPE }; }
  function failure(error: string) { return { error, type: actionTypes.DASHBOARD_FAILURE }; }
}

function getUpcomingEvents() {
  return (dispatch: OpenFieldTypes.RootAction) => {
    dispatch(request());
    dispatch(startLoading('MAIN_LOADER', 'Loading'));
    dashboardServices.getUpcomingEvents()
      .then(
        (res) => {
          dispatch(endLoading('MAIN_LOADER'));
          dispatch(success(res.data));
        },
        (error) => {
          handleError(dispatch, failure, error.toString());
         },
      );
  };
  function request() { return { type: actionTypes.DASHBOARD_UPCOMING_EVENTS_REQUEST }; }
  function success(res: any) { return { type: actionTypes.DASHBOARD_UPCOMING_EVENTS_SUCCESS, res }; }
  function failure(error: string) { return { type: actionTypes.DASHBOARD_UPCOMING_EVENTS_FAILURE, error }; }
}

function getReviews() {
  return (dispatch: OpenFieldTypes.RootAction) => {
    dispatch(request());
    dispatch(startLoading('MAIN_LOADER', 'Loading'));
    dashboardServices.getReviews()
      .then(
        (data) => {
          dispatch(endLoading('MAIN_LOADER'));
          dispatch(success(data));
        },
        (error) => {
          handleError(dispatch, failure, error.toString());
         },
      );
  };
  function request() { return { type: actionTypes.DASHBOARD_REVIEWS_REQUEST }; }
  function success(res: any) { return { type: actionTypes.DASHBOARD_REVIEWS_SUCCESS, res }; }
  function failure(error: string) { return { type: actionTypes.DASHBOARD_FAILURE, error }; }
}
